import React from 'react';
import { Brain, Zap, Code, Database, BarChart, Shield} from 'lucide-react';
import './PrescriptionLanding.css';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import { useMediaQuery } from '@mui/material';
const features = [
  {
    icon: <Brain className="icon" />,
    title: 'Upload Prescription',
    description: 'Upload a clear image of the prescription—handwritten or printed.'
  },
  {
    icon: <Zap className="icon" />,
    title: 'Clear Image Quality',
    description: 'Upload a well-lit, focused image of the full prescription—avoid cut-off edges or glare.'
  },
  {
    icon: <Code className="icon" />,
    title: 'AI-Powered Analysis',
    description: 'Our AI processes the image, identifies medication names, instructions, and converts it into structured text.'
  },
  {
    icon: <Database className="icon" />,
    title: "Doctor’s Notes Visible",
    description: 'Ensure the names of the medications, dosages, and instructions are legible in the image.'
  },
  {
    icon: <BarChart className="icon" />,
    title: ' Get Your Results',
    description: 'Receive an organized summary of medications, ready to review, save, or share.'
  },
  {
    icon: <Shield className="icon" />,
    title: 'Optional Details',
    description: 'If you have additional context (e.g., patient name, date, or diagnosis), include it for a more accurate result'
  },
];

const PrescriptionLanding = () => {
  const navigate = useNavigate();

  const onClickHandle = () => {
    navigate('/prescription/login');
  };

  const isCustomSize = useMediaQuery("(max-width:770px)");
  return (
    <>
    <Header />
      <div className="prescription" style={{padding : '30px'}}>
        <div className="container">
          <div className="wrapper">
            {/* Hero Section */}
            <div className="hero">
              <h1 className="hero-title">
                Prescription <span className="highlight">Detector</span> AI
              </h1>
              <p className="hero-description">
              Our smart Prescription Detector AI extracts clear, structured medication details from handwritten or printed prescriptions in seconds. Simply upload an image—our tool does the rest, making medication records easy to understand and manage.
              </p>
            </div>

            {/* Features */}
            <div className="features-box">
              {!isCustomSize &&  <div style={{display : 'flex' , justifyContent : 'space-around'}}>
                <h2 className="features-heading">How It Works</h2>
                <h2 className="features-heading">What We Ask</h2>
              </div>}
              {isCustomSize && <h2 style={{fontSize : '22px'}} className="features-heading">What This AI Utility Does</h2>}
              <div className="features-grid">
                {features.map((feature, idx) => (
                  <FeaturePoint key={idx} {...feature} />
                ))}
              </div>
            </div>

            {/* CTA */}
            <div className="cta">
              {/* Optional button */}
              <button onClick={onClickHandle} className="cta-button">
                Try AI Utility Now
              </button>
              <p className="cta-note">No coding knowledge required • Easy setup in minutes</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FeaturePoint = ({ icon, title, description }) => (
  <div className="feature-point">
    <div className="icon-container">{icon}</div>
    <div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  </div>
);

export default PrescriptionLanding;
